/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TableMetadataDto } from '../../models/table-metadata-dto';

export interface DatasourcesDataSourceIdTablesGet$Json$Params {
  dataSourceId: string;
}

export function datasourcesDataSourceIdTablesGet$Json(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdTablesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TableMetadataDto>>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdTablesGet$Json.PATH, 'get');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TableMetadataDto>>;
    })
  );
}

datasourcesDataSourceIdTablesGet$Json.PATH = '/datasources/{dataSourceId}/tables';
